export const combineContextAndProps = (context, props) => {
    return {
        ...context,
        ...props,
    };
};
